import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Dotdotdot from 'react-dotdotdot';
import { truncateText } from 'helpers/ContentHelper';
import { SITE_PLATFORM_TABLET, SITE_PLATFORM_MOBILE } from 'helpers/BreakpointHelper';
import Style from './Description.module.scss';

const Description = ({ breakpoint, description }) => {
  const [isDescriptionExpanded, toggleDescription] = useState(false);
  const {
    global_moreButton: descriptionMoreText,
    global_lessButton: descriptionLessText,
  } = window.Language;
  const descriptionWordCount = 258;
  const isDescriptionLong = description && description.length > descriptionWordCount;
  const descriptionText = isDescriptionExpanded
    ? description
    : truncateText(description, descriptionWordCount);
  const descriptionButtonText = isDescriptionExpanded ? descriptionLessText : descriptionMoreText;
  const descriptionButton = isDescriptionLong ? (
    <button
      className={Style.descriptionButton}
      onClick={() => toggleDescription(!isDescriptionExpanded)}
    >
      {descriptionButtonText}
    </button>
  ) : null;
  return (
    <div className={Style.descriptionContainer}>
      {breakpoint === SITE_PLATFORM_MOBILE || breakpoint === SITE_PLATFORM_TABLET ? (
        <>
          <span className={Style.descriptionText}>{descriptionText}</span>
          {descriptionButton}
        </>
      ) : (
        <Dotdotdot clamp={12} className={Style.descriptionText}>
          {description}
        </Dotdotdot>
      )}
    </div>
  );
};

export default Description;

Description.defaultProps = {
  description: '',
};

Description.propTypes = {
  breakpoint: PropTypes.string.isRequired,
  description: PropTypes.string,
};
